import Vue from 'vue'
import get from 'lodash/get'
import omit from 'lodash/omit'
import _kebabCase from 'lodash/kebabCase'

import Store from '@/store'

export default class Package {
  constructor (consumer, type, id, options) {
    this.original = options
    this.consumer = consumer
    this.type = type
    this.id = id
    this.owned = true
    for (let key in options) {
      this[key] = options[key]
    }
    this.isRepo = !(typeof this.repository === 'undefined' || this.repository === null)
    this.category = this.category || 'Other'
    if (!(this.preview != null ? this.preview.length : undefined)) {
      this.preview = ['assets/img/noimage.jpg']
    }
    if (this.original.acl) { delete this.original.acl }
    this.version = 'latest'
    return this
  }
  get canUpdate () { return this.acl && this.acl.update }

  update (key, value) { Vue.set(this, key, value) }
  getName () {
    return get(this.i18n, `${Vue.i18n.locale()}.name`) || Vue.i18n.translate(`${this.consumer}.${_kebabCase(this.name.toLowerCase())}.name`, this.name)
  }
  getDescription () {
    return get(this.i18n, `${Vue.i18n.locale()}.description`) || Vue.i18n.translate(`${this.consumer}.${_kebabCase(this.name.toLowerCase())}.description`, this.description)
  }
  getLongDescription () {
    return get(this.i18n, `${Vue.i18n.locale()}.long_description`) || Vue.i18n.translate(`${this.consumer}.${_kebabCase(this.name.toLowerCase())}.long_description`, this.long_description)
  }
  getStar () { return 5 }
  getAuthor () {
    if (this.author) return `By ${this.author}`
    return ''
  }
  getIcon () { return this.icon || 'assets/img/forepaas.png' }
  getImage () { return this.image || 'assets/img/logofull.png' }
  getTooltipClass () {
    const installed = Store.state.packages.installed
    const language = Store.state.packages.language
    if (installed && installed[this.id] && language) {
      const module = installed[this.id]
      const compare = this.compareUsedVersion(module.version, language)
      if (compare === -1) { return 'yellow' }
    }
    return 'blue'
  }

  getTooltip () {
    const installed = Store.state.packages.installed
    const language = Store.state.packages.language
    if (installed && installed[this.id] && language) {
      const version = installed[this.id].version
      const module = installed[this.id]
      const compare = this.compareUsedVersion(module.version, language)
      if (compare === -1) {
        const availables = this.getVersions(language)
        return Vue.prototype.$t('fpstore.packages.tooltip.detail.update', [version, availables && availables[0]])
      }
      return Vue.prototype.$t('fpstore.packages.tooltip.detail.ok', [version])
    }
    if (this.version && !language) {
      return Vue.prototype.$t('fpstore.packages.tooltip.detail.ok', [this.version])
    }
    return Vue.prototype.$t('fpstore.packages.tooltip.detail')
  }
  getPrice () { return 'Included' }
  hasInstall () { return typeof this.installed !== 'undefined' && this.installed !== null }
  iconIsImage () {
    if (!this.icon) { return true }
    const check = ['.png', '.jpg', '.jpeg']
    for (let val of Array.from(check)) {
      if (this.icon.indexOf(val) !== -1) {
        return true
      }
    }
    return false
  }
  updateOriginal (options) {
    if (options) {
      this.original = options
      return
    }
    this.original = omit(this, [
      'category',
      'consumer',
      'type',
      'id',
      'acl'
    ])
  }
  getVersions () {
    if (!this.versions) { return [] }
    const language = Store.state.packages.language
    const versions = this.versions
      .filter(v => !language || v.indexOf(language) === 0)
      .map(v => (language && v.replace(language + '/', '')) || v)
    if (this.version && !versions.includes(this.version)) {
      versions.push(this.version)
    }
    if (!versions.includes('latest')) versions.push('latest')
    versions.sort(this.compare)
    return versions
  }
  compareUsedVersion (used, language) {
    if (used === 'latest') return 0
    const availables = this.getVersions(language)
    let lastVersion = availables && availables[0]
    if (lastVersion === 'latest' && availables[1]) lastVersion = availables[1]
    if ((lastVersion === used) || (availables.indexOf(used) === -1)) { return 0 }
    return -1
  }
  compare (a, b) {
    if (a === b) { return 0 }
    if (typeof a !== 'string') return 0
    if (typeof b !== 'string') return 0
    if (a === 'latest') return -1
    if (b === 'latest') return 1
    const aComponents = a.split('.')
    const bComponents = b.split('.')
    const len = Math.min(aComponents.length, bComponents.length)
    let i = 0
    while (i < len) {
      if (parseInt(aComponents[i]) > parseInt(bComponents[i])) { return -1 }
      if (parseInt(aComponents[i]) < parseInt(bComponents[i])) { return 1 }
      i++
    }
    if (aComponents.length > bComponents.length) { return -1 }
    if (aComponents.length < bComponents.length) { return 1 }
    return 0
  }
}
